import { BaseModel } from './base-model';

export class RuleManagementUsageOperationModel extends BaseModel {
  providerId: string;
  providerInstanceId: string;
  allUsers: boolean;
  userIds: string[];
  orgUnits: string[];
}
